<template>
   <transition name="modal" mode="out-in">
        <div class="modal__mask" @click="$emit('close')" v-if="show">
            <div class="modal__wrapper">
                <div class="modal__container" @click.stop>
                    <div class="modal__top">
                        <div class="modal__header">
                            <slot name="header">
                            </slot>
                        </div>
                        <button v-if="showCloseButton" class="modal__button button button_with_icon button_type_icon button_color_transp-black" @click="$emit('close')">
                            <svg aria-hidden="true" width="24" height="24">
                                <use href="#icon-close"></use>
                            </svg>
                        </button>
                    </div>

                    <div class="modal__body">
                        <slot name="body">
                        </slot>
                    </div>

                    <div class="modal__footer">
                        <slot name="footer">
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'Modal',
    props:{
        show:{
            type:Boolean,
            default:false
        },
        showCloseButton: {
            type:Boolean,
            default:true
        }
    },
    mounted() {
        document.addEventListener('keydown', (event) => {
            if (event.keyCode === 27) {
                this.$emit('close')
            }
        });
    }
}
</script>